export default __webpack_public_path__ + "static/media/TimeWarningFlash.3e630714.wav";